<template>
  <el-dialog
    :title="editDiaInfo.title"
    :visible.sync="editDiaInfo.show"
    width="800px"
  >
    <div class="big-class-name">{{ className }}</div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="70px"
      size="small"
    >
      <el-form-item label="小班简称:" prop="childName">
        <el-input
          v-model="ruleForm.childName"
          placeholder="请输入小班简称"
          class="input-item"
          maxlength="15"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn @click.native="cancel" title="取消"></butn>
      <butn btntype="primary" @click.native="confirm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  props: {
    editDiaInfo: {
      type: Object,
      default: () => {
        return {
          show: false,
          title: "编辑小级",
          classChildName: "",
        };
      },
    },
    className: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      ruleForm: {
        childName: "",
      }, //
      rules: {
        childName: [{ required: true, message: "", trigger: "blur" }],
      }, //
    };
  },
  created() {
    this.ruleForm.childName = this.editDiaInfo.classChildName;
  },
  methods: {
    cancel() {
      this.$emit("closeEdit");
    },
    confirm() {
      this.$emit("changeSmallClass", this.ruleForm.childName);
    },
  },
};
</script>

<style lang="scss" scoped>
.big-class-name {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 15px;
}
.name-item {
  margin: 0 0 10px 10px;
}
.input-item {
  width: 300px;
  margin-left: 10px;
}
.edit-icon {
  font-size: 20px;
  margin-right: 10px;
  cursor: pointer;
}
</style>
